import { Injectable, inject } from '@angular/core';
import { ModalService } from 'mbs-ui-kit';
import { from, switchMap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadRmmGroupTaskWizardService {
  private modalService = inject(ModalService);
  public isDuplicateMode = false;

  loadWizard() {
    return from(import('../rmm-group-action-wizard.component')).pipe(
      switchMap((importComponent) => this.modalService.openWizard(importComponent.RMMGroupActionWizardComponent))
    );
  }
}
